import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { useMemo } from 'react';
import { propArrayShape, propStr, } from '../../../../../../../helpers/custom-prop-types';
import SharedMember from './SharedMember';
const SharedMembers = (props) => {
    const { className, members } = props;
    const { receivedMembers, unreceivedMembers } = useMemo(() => ({
        receivedMembers: members.filter((v) => v.receivedAt),
        unreceivedMembers: members.filter((v) => !v.receivedAt),
    }), [members]);
    return (_jsxs("div", Object.assign({ className: clsx('proffit_search_folder_share_members', className) }, { children: [_jsx("div", Object.assign({ className: 'title_row' }, { children: "\u5171\u6709\u76F8\u624B\u306E\u958B\u5C01\u72B6\u6CC1" })), _jsxs("div", Object.assign({ className: 'members_row' }, { children: [_jsx(SharedMember, { members: receivedMembers, title: '開封' }), _jsx("div", { className: 'members_divider' }), _jsx(SharedMember, { members: unreceivedMembers, title: '未開封' })] }))] })));
};
SharedMembers.propTypes = {
    className: propStr(),
    members: propArrayShape().isRequired,
};
SharedMembers.defaultProps = {
    className: '',
};
export default SharedMembers;
